


















import { Component, Prop, Vue } from 'vue-property-decorator'
import { trainingCodes } from '@/module/const'
import ChevronsButton from '@/components/ChevronsButton.vue'
import Context from '@/module/Context'

  @Component({
    components: { ChevronsButton }
  })
export default class TrainingsView extends Vue {
    trainingCodes = trainingCodes;

    @Prop({ required: true }) context!: Context;
}
